// API Configuration
// Change this URL to update all API calls throughout the application

// Development
const API_BASE_URL = 'http://localhost:5000';

// Production (uncomment when deploying)
// const API_BASE_URL = 'https://your-production-api.com';

// Staging (uncomment for staging environment)
// const API_BASE_URL = 'https://your-staging-api.com';

export default API_BASE_URL;
